import React from 'react'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import IntervenersList from './IntervenersList'
import IntervenerCards from './IntervenerCards'

export default function ActiveIntervenersTab ({ interveners, deleteModal }) {
  const screens = useBreakpoint()

  return (
    <>
      { !screens.xs && <IntervenersList interveners={interveners} deleteModal={deleteModal} /> }
      { screens.xs && <IntervenerCards interveners={interveners} deleteModal={deleteModal} /> }
    </>
  )
}
